import { type CarrierDef } from '../common.js'
import { type DocumentType } from '../document-types.js'
import { type RoadVisionCredTypes, roadVision } from '../standards.js'

export type dublCredType = RoadVisionCredTypes
export const dublDocumentTypes = [
  'invoice',
  'proof-of-delivery',
  'signed-bol',
] as const satisfies readonly DocumentType[]

export const dubl: CarrierDef<dublCredType> = {
  name: 'Dugan Truck Line',
  scac: 'dubl',
  ltlServices: [{ id: 'standard', name: 'Standard' }],
  ...roadVision,
  engineLayers: [
    'rating',
    'pickup',
    'tracking',
    'profinder',
    'documents',
    'invoice',
  ],
  documentTypes: dublDocumentTypes,
}
